module.exports = __webpack_public_path__ + "video/800-4_SERF_2022_EmailRedFlags.34ac4692.vtt";